import { useCallback, useRef } from 'react'
import { speakOnce, cancelSpeech } from '../services/speech'
import { chosenLang } from '../utils/text'

export function useSpeech() {
  const speakingRef = useRef(false)
  const pendingSpeechRef = useRef(false)
  const currentSpeechIdRef = useRef<string | null>(null)

  const speak = useCallback((text: string, lang?: string) => {
    if (!text) return

    // Cancel any ongoing speech first
    cancelSpeech()
    
    // Generate unique ID for this speech request
    const speechId = `${Date.now()}-${Math.random()}`
    currentSpeechIdRef.current = speechId

    // Reset state
    pendingSpeechRef.current = true
    speakingRef.current = false

    speakOnce(
      text,
      lang || chosenLang(),
      () => {
        // Only update state if this is still the current speech
        if (currentSpeechIdRef.current === speechId) {
          pendingSpeechRef.current = false
          speakingRef.current = true
        }
      },
      () => {
        // Only update state if this is still the current speech
        if (currentSpeechIdRef.current === speechId) {
          pendingSpeechRef.current = false
          speakingRef.current = false
          currentSpeechIdRef.current = null
        }
      },
      () => {
        // Only update state if this is still the current speech
        if (currentSpeechIdRef.current === speechId) {
          pendingSpeechRef.current = false
          speakingRef.current = false
          currentSpeechIdRef.current = null
        }
      }
    )
  }, [])

  const cancel = useCallback(() => {
    cancelSpeech()
    speakingRef.current = false
    pendingSpeechRef.current = false
    currentSpeechIdRef.current = null
  }, [])

  return { speak, cancel, isSpeaking: () => speakingRef.current || pendingSpeechRef.current }
}
